module.exports = {
    pf: {
        title: 'O que pretende fazer agora? Já quer começar a doar?',
        options: [
            {
                text: 'Não vou realizar uma doação agora'
            },
            {
                text: 'Indicar itens a serem doados após a aprovação do cadastro'
            }
        ],
        messagePlaceholder: 'Escreva aqui o item que você pode contribuir'
    },
    ong: {
        title: 'O que pretende fazer agora? Já quer cadastrar suas necessidades?',
        options: [
            {
                text: 'Não quero cadastrar minhas necessidades agora'
            },
            {
                text: 'Quero cadastrar uma necessidade agora'
            }
        ],
        messagePlaceholder: 'Escreva aqui o item que você pode contribuir'
    },
    pj: {
        title: 'O que pretende fazer agora? Já quer começar a doar?',
        options: [
            {
                text: 'Não vou realizar uma doação agora'
            },
            {
                text: 'Indicar itens a serem doados após a aprovação do cadastro'
            }
        ],
        messagePlaceholder: 'Escreva aqui o item que você pode contribuir'
    },
}